var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 14 17.5",
    width: 14,
    height: 17.5,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,0.8c3.3,0,6.1,2.6,6.1,5.7c0,0.8-0.5,3.4-5.5,9.9c-0.1,0.2-0.3,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.3 c-5-6.5-5.5-9.1-5.5-9.9C0.9,3.4,3.7,0.8,7,0.8 M7,17.5c0.5,0,1-0.2,1.3-0.6C10.4,14.2,14,9.1,14,6.5C14,2.9,10.9,0,7,0 S0,2.9,0,6.5c0,2.6,3.6,7.6,5.7,10.4C6,17.3,6.5,17.5,7,17.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,6.5c0-1.2,1.1-2.2,2.4-2.2s2.4,1,2.4,2.2S8.3,8.7,7,8.7S4.6,7.7,4.6,6.5 M10.3,6.5c0-1.7-1.5-3.1-3.3-3.1 S3.7,4.8,3.7,6.5S5.2,9.6,7,9.6S10.3,8.2,10.3,6.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.eb35f7a7c3512bf2ab11753c48790d4b.svg";
export { ForwardRef as ReactComponent };